(function () {
  var STORAGE_KEY = 'mii_favorites';

  function canUseStorage() {
    try {
      var testKey = STORAGE_KEY + '_test';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  var storageAvailable = canUseStorage();

  function readFavorites() {
    if (!storageAvailable) return [];
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(function (item) {
        return item && item.variantId;
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(items) {
    if (!storageAvailable) return false;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('mii:favorites:change', {
        detail: { favorites: items }
      }));
      return true;
    } catch (error) {
      return false;
    }
  }

  function normalizeVariantId(variantId) {
    return String(variantId || '');
  }

  function isFavorite(variantId) {
    var normalizedId = normalizeVariantId(variantId);
    return readFavorites().some(function (item) {
      return normalizeVariantId(item.variantId) === normalizedId;
    });
  }

  function upsertFavorite(item) {
    var normalizedId = normalizeVariantId(item && item.variantId);
    if (!normalizedId) return false;

    var favorites = readFavorites().filter(function (favorite) {
      return normalizeVariantId(favorite.variantId) !== normalizedId;
    });

    favorites.unshift(Object.assign({}, item, {
      variantId: normalizedId,
      productId: normalizeVariantId(item.productId),
      addedAt: item.addedAt || new Date().toISOString()
    }));

    return writeFavorites(favorites);
  }

  function removeFavorite(variantId) {
    var normalizedId = normalizeVariantId(variantId);
    if (!normalizedId) return false;

    var favorites = readFavorites().filter(function (item) {
      return normalizeVariantId(item.variantId) !== normalizedId;
    });

    return writeFavorites(favorites);
  }

  function formatMoney(price) {
    var value = Number(price);
    if (!Number.isFinite(value)) return '';
    return '¥' + Math.round(value / 100).toLocaleString('ja-JP');
  }

  function productUrl(handle, variantId, fallbackUrl) {
    var url = fallbackUrl || (handle ? '/products/' + handle : '#');
    if (!variantId) return url;

    var hashParts = url.split('#');
    var queryParts = hashParts[0].split('?');
    var baseUrl = queryParts[0];
    var params = queryParts[1] ? queryParts[1].split('&').filter(function (param) {
      return param && param.split('=')[0] !== 'variant';
    }) : [];

    params.push('variant=' + encodeURIComponent(variantId));
    return baseUrl + '?' + params.join('&') + (hashParts[1] ? '#' + hashParts[1] : '');
  }

  function parseProductData() {
    var node = document.getElementById('mii-favorite-product-data');
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      data.variants = Array.isArray(data.variants) ? data.variants : [];
      return data;
    } catch (error) {
      return null;
    }
  }

  function findVariant(productData, variantId) {
    if (!productData) return null;
    var normalizedId = normalizeVariantId(variantId);
    return productData.variants.find(function (variant) {
      return normalizeVariantId(variant.id) === normalizedId;
    }) || productData.variants[0] || null;
  }

  function getCurrentVariantId() {
    var variantInput = document.getElementById('variant-id-input') ||
      document.querySelector('#product-form [name="id"]');
    return variantInput ? normalizeVariantId(variantInput.value) : '';
  }

  function buildFavoriteItem(productData, variantId) {
    var variant = findVariant(productData, variantId);
    if (!productData || !variant) return null;
    var normalizedId = normalizeVariantId(variant.id);

    return {
      handle: productData.handle,
      productId: normalizeVariantId(productData.productId),
      variantId: normalizedId,
      title: productData.title,
      url: productUrl(productData.handle, normalizedId, productData.url),
      image: variant.image || productData.image || '',
      price: variant.price,
      variantTitle: variant.title === 'Default Title' ? '' : variant.title,
      addedAt: new Date().toISOString()
    };
  }

  function updateProductFavoriteButton(button, productData) {
    var variantId = getCurrentVariantId();
    var active = isFavorite(variantId);
    var icon = button.querySelector('.product-info__favorite-icon');

    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    if (icon) icon.textContent = active ? '♥' : '♡';

    var productTitle = productData && productData.title ? productData.title : '商品';
    button.setAttribute(
      'aria-label',
      productTitle + (active ? 'をお気に入りから削除' : 'をお気に入りに追加')
    );
  }

  function initProductFavorite() {
    var button = document.querySelector('[data-mii-favorite-button]');
    var productData = parseProductData();
    if (!button || !productData) return;

    function refresh() {
      updateProductFavoriteButton(button, productData);
    }

    button.addEventListener('click', function () {
      var variantId = getCurrentVariantId();
      if (!variantId) return;

      if (isFavorite(variantId)) {
        removeFavorite(variantId);
      } else {
        var item = buildFavoriteItem(productData, variantId);
        if (item) upsertFavorite(item);
      }

      refresh();
    });

    document.addEventListener('mii:variant-change', refresh);
    document.addEventListener('mii:favorites:change', refresh);
    refresh();
  }

  function setMessage(root, text) {
    var message = root.querySelector('[data-mii-favorites-message]');
    if (message) message.textContent = text || '';
  }

  function createTextElement(tagName, className, text) {
    var el = document.createElement(tagName);
    el.className = className;
    el.textContent = text || '';
    return el;
  }

  function createFavoriteCard(item, root) {
    var card = document.createElement('article');
    card.className = 'favorite-page__card';
    card.setAttribute('data-favorite-variant-id', item.variantId);

    var imageLink = document.createElement('a');
    imageLink.className = 'favorite-page__image-link';
    imageLink.href = item.url || '#';

    if (item.image) {
      var image = document.createElement('img');
      image.className = 'favorite-page__image';
      image.src = item.image;
      image.alt = item.title || '';
      image.loading = 'lazy';
      imageLink.appendChild(image);
    }

    var body = document.createElement('div');
    body.className = 'favorite-page__body';

    var name = createTextElement('a', 'favorite-page__name', item.title);
    name.href = item.url || '#';
    body.appendChild(name);

    if (item.variantTitle) {
      body.appendChild(createTextElement('p', 'favorite-page__variant', item.variantTitle));
    }

    body.appendChild(createTextElement('p', 'favorite-page__price', formatMoney(item.price)));

    var actions = document.createElement('div');
    actions.className = 'favorite-page__actions';

    var addButton = document.createElement('button');
    addButton.type = 'button';
    addButton.className = 'favorite-page__button favorite-page__button--add';
    addButton.textContent = item.available === false ? '売り切れ' : 'カートに追加';
    addButton.disabled = item.available === false;
    addButton.addEventListener('click', function () {
      addFavoriteToCart(item, root, addButton);
    });

    var removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'favorite-page__button favorite-page__button--remove';
    removeButton.textContent = '削除';
    removeButton.addEventListener('click', function () {
      removeFavorite(item.variantId);
      renderFavoriteList(root, readFavorites());
    });

    actions.appendChild(addButton);
    actions.appendChild(removeButton);
    body.appendChild(actions);

    card.appendChild(imageLink);
    card.appendChild(body);
    return card;
  }

  function addFavoriteToCart(item, root, button) {
    if (!item || !item.variantId) return;
    setMessage(root, '');
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: Number(item.variantId),
        quantity: 1
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart add failed');
      window.location.reload();
    }).catch(function () {
      button.disabled = false;
      setMessage(root, 'カートに追加できませんでした。時間をおいて再度お試しください。');
    });
  }

  function renderFavoriteList(root, favorites) {
    var list = root.querySelector('[data-mii-favorites-list]');
    var empty = root.querySelector('[data-mii-favorites-empty]');
    if (!list || !empty) return;

    list.textContent = '';
    setMessage(root, '');

    if (!favorites.length) {
      empty.classList.remove('is-hidden');
      return;
    }

    empty.classList.add('is-hidden');
    favorites.forEach(function (item) {
      list.appendChild(createFavoriteCard(item, root));
    });
  }

  function favoriteSignature(favorites) {
    return favorites.map(function (item) {
      return normalizeVariantId(item.variantId);
    }).join(',');
  }

  function refreshProductData(item) {
    if (!item || !item.handle) return Promise.resolve(item);

    return fetch('/products/' + encodeURIComponent(item.handle) + '.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('product fetch failed');
      return response.json();
    }).then(function (product) {
      var variant = (product.variants || []).find(function (candidate) {
        return normalizeVariantId(candidate.id) === normalizeVariantId(item.variantId);
      });
      if (!variant) return item;

      return Object.assign({}, item, {
        title: product.title || item.title,
        url: productUrl(product.handle || item.handle, variant.id, product.url || item.url),
        image: (variant.featured_image && variant.featured_image.src) || product.featured_image || item.image,
        price: variant.price,
        variantTitle: variant.title === 'Default Title' ? '' : variant.title,
        available: variant.available
      });
    }).catch(function () {
      return item;
    });
  }

  function initFavoritePage() {
    var root = document.querySelector('[data-mii-favorites-page]');
    if (!root) return;

    var favorites = readFavorites();
    var initialSignature = favoriteSignature(favorites);
    renderFavoriteList(root, favorites);
    if (!favorites.length) return;

    Promise.all(favorites.map(refreshProductData)).then(function (freshFavorites) {
      var currentFavorites = readFavorites();
      if (favoriteSignature(currentFavorites) !== initialSignature) {
        renderFavoriteList(root, currentFavorites);
        return;
      }

      writeFavorites(freshFavorites);
      renderFavoriteList(root, freshFavorites);
    });
  }

  window.MiiFavorites = {
    key: STORAGE_KEY,
    read: readFavorites,
    write: writeFavorites,
    remove: removeFavorite,
    isFavorite: isFavorite,
    formatMoney: formatMoney
  };

  document.addEventListener('DOMContentLoaded', function () {
    initProductFavorite();
    initFavoritePage();
  });
})();
